import { Box, Stack, Typography } from '@mui/material'
import { AppUserDisplayName } from 'components/pages/app/users/app-user-display-name'
import { C1EntitlementDisplayName } from 'components/pages/entitlement/display-name'
import { UserDisplayName } from 'components/pages/user/user-display-name'
import { AppEntitlementValue } from 'lib/actions/apps/app-entitlement'
import { AppUserValue } from 'lib/actions/apps/app-users'
import { UserValue } from 'lib/actions/user'
import { FC } from 'react'
import { FormattedMessage } from 'react-intl'

type RenderEntitlementsForDialogProps = {
    entitlements: AppEntitlementValue[]
}
export const RenderEntitlementsForDialog: FC<RenderEntitlementsForDialogProps> = ({ entitlements }) => {
    return (
        <Stack direction="column" spacing={2}>
            <Typography variant="h6">
                <FormattedMessage
                    id="access_request_entitlements_dialog_label"
                    defaultMessage="Entitlements"
                />
            </Typography>
            <Box sx={{
                display: 'flex',
                width: '100%',
                flexWrap: 'wrap',
                gap: 4,
            }}
            >
                {entitlements.map((entitlement) => (
                    <Box key={`${entitlement.id}-${entitlement.appId}`} sx={{ minWidth: 0, flex: '0 0 auto' }}>
                        <C1EntitlementDisplayName entitlement={entitlement} />
                    </Box>
                ))}
            </Box>
        </Stack>
    )
}

export const RenderAppUserForDialog: FC<{ appUser: AppUserValue }> = ({ appUser }) => {
    return (
        <Stack direction="column" spacing={2}>
            <Typography variant="h6">
                <FormattedMessage
                    id="access_request_app_user_dialog_label"
                    defaultMessage="App user"
                />
            </Typography>
            <AppUserDisplayName appUser={appUser} readOnly />
        </Stack>
    )
}

export const RenderUserForDialog: FC<{ user: UserValue }> = ({ user }) => {
    return (
        <Stack direction="column" spacing={2}>
            <Typography variant="h6">
                <FormattedMessage
                    id="access_request_user_dialog_label"
                    defaultMessage="User"
                />
            </Typography>
            <UserDisplayName user={user} readOnly />
        </Stack>
    )
}
